const GROUP_SUBJECTS = {
  "3": [
    "Art History",
    "Brazilian Social Studies",
    "Business Management",
    "Economics",
    "Environmental Systems and Societies",
    "Geography",
    "Global Politics",
    "History",
    "Digital Society",
    "Philosophy",
    "Psychology",
    "Social and Cultural Anthropology",
    "Turkey in the 20th Century",
    "World Religions",
  ],
  "4": [
    "Astronomy",
    "Biology",
    "Chemistry",
    "Computer Science",
    "Design Technology",
    "Environmental Systems and Societies",
    "Marine Science",
    "Nature of Science",
    "Physics",
    "Sports, Exercise and Health Science",
  ],
  "6": [
    "Dance",
    "Film",
    "Music",
    "Theatre",
    "Visual Arts",
    "Literature and Performance",
  ],
};

const normalizeSpaces = (value) => value.replace(/\s+/g, " ").trim();
const normalizeForMatch = (value) =>
  normalizeSpaces(value)
    .replace(/\bAnd\b/gi, "and")
    .toLowerCase();

const toSlug = (value) =>
  normalizeForMatch(value)
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const GROUP_SUBJECT_LOOKUPS = Object.fromEntries(
  Object.entries(GROUP_SUBJECTS).map(([groupId, subjects]) => [
    groupId,
    new Set(subjects.map(normalizeForMatch)),
  ])
);

const GROUP_ONE_REGEX = /^(SL|HL)\s+.+?\s+A:\s+.+$/i;
const GROUP_TWO_REGEX = /^(SL|HL)\s+.+?\s+(B|ab initio)$/i;
const LEVEL_PREFIX_REGEX = /^(SL|HL)\s+(.+)$/i;
const MATH_PREFIX_REGEX = /^Mathematics:?\s+(.+)$/i;

const getLevelAndSubjectPart = (subjectKey) => {
  const match = subjectKey.match(LEVEL_PREFIX_REGEX);
  if (!match) return { level: null, subjectPart: null };
  return {
    level: match[1].toUpperCase(),
    subjectPart: normalizeSpaces(match[2]),
  };
};

const resolveStaticGroupId = (subjectPart) => {
  const normalized = normalizeForMatch(subjectPart);

  if (normalized.startsWith("history ")) return "3";
  for (const [groupId, subjectLookup] of Object.entries(GROUP_SUBJECT_LOOKUPS)) {
    if (subjectLookup.has(normalized)) return groupId;
  }
  return null;
};

export const classifyBoundarySubjectKey = (subjectKey) => {
  if (!subjectKey) return null;
  if (GROUP_ONE_REGEX.test(subjectKey)) return "1";
  if (GROUP_TWO_REGEX.test(subjectKey)) return "2";

  const { subjectPart } = getLevelAndSubjectPart(subjectKey);
  if (!subjectPart) return null;

  if (MATH_PREFIX_REGEX.test(subjectPart)) return "5";
  return resolveStaticGroupId(subjectPart);
};

export const getBoundarySubjectMeta = (subjectKey) => {
  if (!subjectKey) return null;
  const groupId = classifyBoundarySubjectKey(subjectKey);
  if (!groupId) return null;

  const { level, subjectPart } = getLevelAndSubjectPart(subjectKey);
  const baseSubject =
    subjectPart && MATH_PREFIX_REGEX.test(subjectPart)
      ? normalizeSpaces(subjectPart.replace(MATH_PREFIX_REGEX, "$1"))
      : subjectPart;

  const subjectIdBase = baseSubject ? toSlug(baseSubject) : toSlug(subjectKey);
  const subjectId = `g${groupId}_${subjectIdBase}`;
  const boundaryEntryId = level ? `${subjectId}_${level.toLowerCase()}` : subjectId;

  return {
    subjectKey,
    groupId,
    level,
    subjectLabel: baseSubject || subjectKey,
    subjectId,
    boundaryEntryId,
  };
};
